/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsJoin = createReactComponent("outline", "arrows-join", "IconArrowsJoin", [["path", { "d": "M3 7h5l3.5 5h9.5", "key": "svg-0" }], ["path", { "d": "M3 17h5l3.495 -5", "key": "svg-1" }], ["path", { "d": "M18 15l3 -3l-3 -3", "key": "svg-2" }]]);

export { IconArrowsJoin as default };
//# sourceMappingURL=IconArrowsJoin.mjs.map
